import React from "react";
import { useTranslation } from 'react-i18next';
import Quarries from "../Components/quarries/Quarries";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import seoData from "../data/seoData.json";

function QuarriesPage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = seoData[currentLang]?.quarries || seoData.en.quarries;

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/ocaklarimiz"
      />
      <TopBar />
      <Spacer/>
      <Spacer/>
      <Quarries />
    </>
  );
}

export default QuarriesPage;
